(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cs-buy]').forEach(box => {
      if (box.dataset.initialized) return;
      box.dataset.initialized = 'true';
      const form = box.querySelector('form');
      const quantity = box.querySelector('[data-cs-quantity]');
      const image = box.querySelector('.cs-gallery-main');
      const add = box.querySelector('[data-cs-add]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: box.dataset.currency || 'USD'});
      const showImage = src => {
        if (!image || !src) return;
        image.removeAttribute('srcset');
        image.src = src;
      };
      const update = (changeImage = false) => {
        const selected = form.querySelector('[data-cs-variant]:checked');
        if (!selected) return;
        const cents = Number(selected.dataset.price);
        box.querySelector('[data-cs-price]').textContent = money.format(cents / 100);
        const total = box.querySelector('[data-cs-total]');
        if (total && quantity) total.textContent = money.format(cents * Number(quantity.value) / 100);
        box.querySelector('[data-cs-color]').textContent = selected.dataset.title;
        add.disabled = selected.dataset.available !== 'true';
        add.textContent = add.disabled ? add.dataset.soldout : add.dataset.label;
        if (changeImage) {
          showImage(selected.dataset.image);
          image.alt = selected.dataset.title + ' Chair Socks';
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
        }
      };
      // Bundle changes belong to Kaching; only update native theme controls here.
      form.addEventListener('change', event => {
        if (event.target.matches('[data-cs-variant], [data-cs-quantity]')) {
          update(event.target.matches('[data-cs-variant]'));
        }
      });
      box.querySelectorAll('[data-cs-photo]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.csPhoto)));
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
